import { useMutation, useQueryClient } from 'react-query'
import request from '../../../request'
import { useDealership } from '../../../../store/zustand/dealershipStore'
export const useEditVendorCampaignByDealershipId = () => {
  const dealership = useDealership()
  const queryClient = useQueryClient()
  return useMutation(
    ({
      data,
    }: {
      data: {
        campaign_id: any
        vendor_id: number
        customer_account_id: string
        login_customer_id: string
        status: string
      }
    }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/self-service/edit`,
        method: 'POST',
        data,
      }),
    {
      onMutate: async ({ data }) => {
        await queryClient.cancelQueries([
          'dealership',
          dealership?.id,
          'campaigns',
          'self-service',
          'list',
        ])
        const previousCampaigns = queryClient.getQueriesData([
          'dealership',
          dealership?.id,
          'campaigns',
          'self-service',
          'list',
        ])
        previousCampaigns.map(([queryKey]) => {
          queryClient.setQueryData(queryKey, (old: any) => {
            return {
              ...old,
              data: old.data.map((campaign: any) => {
                if (campaign.vendor_campaign.id === data.campaign_id) {
                  return {
                    ...campaign,
                    vendor_campaign: {
                      ...campaign.vendor_campaign,
                      status_name: data.status === 'paused' ? 'active' : 'paused',
                    },
                  }
                }
                return campaign
              }),
            }
          })
        })
        return { previousCampaigns }
      },
    },
  )
}
